var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSupported)?[_c(_vm.isSupported,{tag:"component",attrs:{"field":_vm.field}})]:[_c('a-alert',{attrs:{"message":"Chưa hỗ trợ kiểu dữ liệu này!","banner":""}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }